export class ThirdPartyNotificationClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/third_party/notifications/count`;
  }

  async statToday() {
    const url = `${this.baseURL}/today`;

    const response = await this.httpClient.request("get", url);

    return response.data;
  }
}
